import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import './css/actividadesNomina.css';
import vr from '../../../../utils/Verifiers';
import SupervisoresReporte from './subsecciones/SupervisoresReporte';
import FechasReporte from './subsecciones/FechasReporte';
import NominasPorEmpleado from './subsecciones/NominasPorEmpleado';
import NominasPorDia from './subsecciones/NominasPorDia';

const ActividadesNomina = () => {
    const fechaFormato = (fecha) => {
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
        const dia = String(fecha.getDate()).padStart(2, '0');

        return `${anio}-${mes}-${dia}`;
    }

    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [seccion, setseccion] = useState('supervisores');
    const [reportes, setreportes] = useState({ datos: [], fechas: [], grupos: [], supervisores: [] });
    const [tiempos, settiempos] = useState({ semana: "", fecha: fechaFormato(new Date()) });
    useEffect(() => {
        const sels = { fecha_inicio: obtenerDiaMasProximo("miercoles"), fecha_fin: fechaFormato(new Date()), semana: "" };
        settiempos(sels);
        getReporte(sels);
    }, []);



    const getReporte = async (payload = { ...tiempos }) => {
        const resp = await vr.getDataAPI('nomina/administrador/reporte', payload, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        setreportes({ ...resp.data });
    }

    function obtenerDiaMasProximo(dia) {
        const dias = {
            "lunes": 1,
            "martes": 2,
            "miercoles": 3,
            "jueves": 4,
            "viernes": 5,
            "sabado": 6,
            "domingo": 0
        };
        if (!dias.hasOwnProperty(dia.toLowerCase())) {
            dia = 1
        } else {
            dia = dias[dia.toLowerCase()];
        }
        let fecha = new Date();

        while (fecha.getDay() !== dia) {
            fecha.setDate(fecha.getDate() - 1);
        }

        return fechaFormato(fecha);
    }

    const contenidoSubseccion = () => {
        switch (seccion) {
            case 'supervisores':
                return tablaSupervisores();
            case 'fechas':
                return (<FechasReporte reportes={reportes} />);
            case 'nomina':
                return (<NominasPorEmpleado reportes={reportes} />);
            case 'dias':
                return (<NominasPorDia reportes={reportes} />);
        }
    }

    const tablaSupervisores = () => {
        return (<SupervisoresReporte reportes={reportes} />);
    }

    const botonSubSeccion = (nombreSeccion, clave) => (
        <div className={`seccion-menu-responsiva  transition-s text-bold ${seccion === clave ? 'seccion-seleccionada' : 'seccion-seleccionable'}`}
            onClick={() => setseccion(clave)}>
            {nombreSeccion}
        </div>
    );

    const cambiarTiempo = (e) => {
        const { name, value } = e.target;
        const payload = { semana: "", fecha_inicio: "", fecha_fin: "" };
        if (name === "semana") {
            const len = value.length;
            if (len !== 4) {
                settiempos({ ...payload, semana: value });
                return;
            }
            let anio = value.substring(0, 2).trim();
            let semana = value.substring(2, 4).trim();
            if (anio.length !== 2 || semana.length !== 2) {
                settiempos({ ...payload, semana: value });
                return;
            }
            anio = vr.numberFormat(anio, 0);
            semana = vr.numberFormat(semana, 0);
            if (anio < 20 || semana < 1 || semana > 53) {
                settiempos({ ...payload, semana: value });
                return;
            }
            payload.semana = value;
        } else if (['fecha_inicio', 'fecha_fin'].includes(name)) {
            if (!value) return;
            payload[name] = value;
            if (name === 'fecha_inicio') payload.fecha_fin = tiempos.fecha_fin;
            else payload.fecha_inicio = tiempos.fecha_inicio;
        }
        settiempos(payload);
        getReporte(payload);
    }

    return (
        <>
            <div className='vh-100 w-100 bg-white m-0 p-1' style={{ position: 'fixed', top: 0, left: 0, }}>
                <div className='row justify-content-evenly w-100 m-0 p-0 ' style={{ position: 'relative' }}>
                    <div className='grid-secciones w-100'>
                        {botonSubSeccion('Supervisores', 'supervisores')}
                        {botonSubSeccion('Fechas', 'fechas')}
                        {botonSubSeccion('Nóminas - empleado', 'nomina')}
                        {botonSubSeccion('Ordenes por día', 'dias')}
                    </div>
                    <div className='form-group bw-200'>
                        <label className='text-bold'>Semana</label>
                        <input type='text' className='form-control form-control-sm' name="semana" placeholder='' value={tiempos.semana} onChange={cambiarTiempo} />
                    </div>
                    <div className='form-group bw-200'>
                        <label className='text-bold'>Fecha desde</label>
                        <input type='date' className='form-control form-control-sm' name="fecha_inicio" value={tiempos.fecha_inicio} onChange={cambiarTiempo} />
                    </div>
                    <div className='form-group bw-200'>
                        <label className='text-bold'>Fecha hasta</label>
                        <input type='date' className='form-control form-control-sm' name="fecha_fin" value={tiempos.fecha_fin} onChange={cambiarTiempo} />
                    </div>
                    <div className='w-100 m-0 p-0'></div>
                    {contenidoSubseccion()}
                </div>
            </div>
            {loader && ldr}
            {<VainillaDialog data={dialog} setdialog={setdialog} />}
        </>

    )
}

export default ActividadesNomina; 